"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationErrorReasons = void 0;
var GenerationErrorReasons;
(function (GenerationErrorReasons) {
    GenerationErrorReasons["BAD_SUMMARY_FORMAT"] = "BAD_SUMMARY_FORMAT";
    GenerationErrorReasons["SUMMARY_MODULE_TOO_SHORT"] = "SUMMARY_MODULE_TOO_SHORT";
    GenerationErrorReasons["SUMMARY_MODULE_TOO_LONG"] = "SUMMARY_MODULE_TOO_LONG";
    GenerationErrorReasons["MULTIPLE_CHOICE_QUESTION_COUNT_TOO_SHORT"] = "MULTIPLE_CHOICE_QUESTION_COUNT_TOO_SHORT";
    GenerationErrorReasons["MULTIPLE_CHOICE_QUESTION_COUNT_TOO_LONG"] = "MULTIPLE_CHOICE_QUESTION_COUNT_TOO_LONG";
    GenerationErrorReasons["WORD_FILL_QUESTION_COUNT_TOO_SHORT"] = "WORD_FILL_QUESTION_COUNT_TOO_SHORT";
    GenerationErrorReasons["GPT_REQUEST_ERROR"] = "GPT_REQUEST_ERROR";
    GenerationErrorReasons["ERROR_PARSING_MODULE"] = "ERROR_PARSING_MODULE";
    GenerationErrorReasons["UNKNOWN_MODULE_TYPE"] = "UNKNOWN_MODULE_TYPE";
    GenerationErrorReasons["MISSING_RESOURCE_TEXT"] = "MISSING_RESOURCE_TEXT";
    GenerationErrorReasons["RESOURCE_TEXT_TOO_SHORT"] = "RESOURCE_TEXT_TOO_SHORT";
    GenerationErrorReasons["RESOURCE_TEXT_TOO_LONG"] = "RESOURCE_TEXT_TOO_LONG";
})(GenerationErrorReasons = exports.GenerationErrorReasons || (exports.GenerationErrorReasons = {}));
//# sourceMappingURL=GenerationErrorReasons.js.map